module.exports = __webpack_public_path__ + "img/header-weddingRingsMillgrif@2x.919bd15.webp";